import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzAccordionItem',
  props: {
    count: {
      default: 0
    },
    name: {
      default: 'accordion'
    },
    open: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var openState = ref(props.open);
    var detailsElement = ref(null);
    var summaryElement = ref(null);

    /**
     * Ignores the first scroll if the item is opened by default
     * to avoid scrolling to it when the page is loading.
     */
    var ignoreFirstScroll = ref(props.open);
    /**
     * Will scroll the details element into view
     */
    function onToggle() {
      var _detailsElement$value, _detailsElement$value2;
      openState.value = (_detailsElement$value = detailsElement.value) === null || _detailsElement$value === void 0 ? void 0 : _detailsElement$value.open;
      if ((_detailsElement$value2 = detailsElement.value) !== null && _detailsElement$value2 !== void 0 && _detailsElement$value2.open && summaryElement.value && !ignoreFirstScroll.value) {
        summaryElement.value.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      ignoreFirstScroll.value = false;
    }
    return {
      __sfc: true,
      props: props,
      openState: openState,
      detailsElement: detailsElement,
      summaryElement: summaryElement,
      ignoreFirstScroll: ignoreFirstScroll,
      onToggle: onToggle
    };
  }
});